import { SEND_MESSAGE, DELETE_MESSAGE } from './types';
const initialState = {
    messages: [
        {
            user: '1string',
            message: 'as tring',
            timestamp: 1,
        },
    ],
};
// eslint-disable-next-line import/prefer-default-export
export function chatReducer(state = initialState, action) {
    switch (action.type) {
        case SEND_MESSAGE:
            return {
                messages: [...state.messages, action.payload],
            };
        case DELETE_MESSAGE:
            return {
                messages: state.messages.filter((message) => message.timestamp !== action.meta.timestamp),
            };
        default:
            return state;
    }
}
